import React from "react";
import Link from "next/link";
import cn from "classnames";

import type { LayoutType } from "../../../../../utils/layout";
import type { Url } from "../../../../../types/content";

import styles from "./ArticleLink.module.scss";
import { Icon } from "../../../../Icon/Icon";

const getIsOmniKey = (resource: Url, urlIndex?: number) => {
  if (resource.metadata?.omnikey) {
    if (resource.metadata.limited && (!urlIndex || urlIndex > 1)) {
      return false;
    }

    return true;
  }

  return false;
};

const ArticleLink = ({
  resource,
  layoutType,
  isPremium,
  isUserPremium,
  urlIndex,
}: {
  resource: Url;
  layoutType?: LayoutType;
  isPremium?: boolean;
  isUserPremium?: boolean;
  urlIndex?: number;
}) => {
  const isLongArticle =
    layoutType === "longform" || layoutType === "explaining";
  const isNewsArticle = layoutType === "news";
  const isSponsored = layoutType === "native";
  const isOmniKey = getIsOmniKey(resource, urlIndex);

  return (
    <div
      className={cn([
        styles.linkContainer,
        layoutType && styles[layoutType],
        resource.sponsored && styles.native,
      ])}
    >
      <div
        data-testid="articleLink"
        className={cn([
          styles.innerLinkContainer,
          layoutType && styles[layoutType],
          resource.sponsored && styles.native,
        ])}
      >
        {resource.sponsored && (
          <div className={styles.sponsoredLabel}>Annons</div>
        )}
        <Link
          href={resource.url}
          target="_blank"
          className={styles.link}
          prefetch={false}
        >
          <span
            className={cn([
              styles.titleText,
              layoutType && styles[layoutType],
              isPremium && styles.premiumTitleText,
              resource.sponsored && styles.native,
            ])}
          >
            {resource?.title?.value?.trim()}
          </span>
          {!isNewsArticle && !isSponsored && (
            <span data-testid="liscensedLinkCaret" className={styles.arrow}>
              <Icon
                variant="caretRight"
                size="small"
                className={cn([styles.icon, isPremium && styles.premiumIcon])}
              />
            </span>
          )}
        </Link>
        {!isLongArticle && (
          <div className={cn([styles.meta, layoutType && styles[layoutType]])}>
            {resource.label && (
              <span
                className={cn([styles.label, layoutType && styles[layoutType]])}
              >
                {resource.label}&nbsp;·&nbsp;
              </span>
            )}
            {resource.source}
            {resource.paywall == "Hard" && (
              <span
                className={cn([isUserPremium && isOmniKey && styles.unlocked])}
              >
                &nbsp;{`${resource.source_suffix?.value}`}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export { ArticleLink };
